import React, { useState } from 'react'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { useAccessCard } from '../ContextProvider/Accesscardprovider'

const Home = () => {
    const {card} = useAccessCard();
    const [openSidebarToggle, setOpenSidebarToggle] = useState(false)
    // const [showOtpReg, setShowOtpReg] = useState(false);
    // const [showUserDetailReg,setShowUserDetailReg] = useState(false);
    const [enroll,setEnroll] = useState(false);

    const closeBar = () => {
        setOpenSidebarToggle(false)
    }

    const accessEnrollCourse = () => {
        setEnroll(!enroll);
    }

    // const accessUserDetailReg = () => {
    //     setShowUserDetailReg(!showUserDetailReg)
    // }

    // const accessOtpReg = () => {
    //     setShowOtpReg(!showOtpReg);
    // }

    const OpenSidebar = () => {
        setOpenSidebarToggle(!openSidebarToggle)
    }

    return (
        <div>
            <div className={`overlay ${card ? 'active' : ''}`}></div>
            <Navbar
                OpenSidebar={OpenSidebar}
            />
            <Sidebar
                enroll={enroll}
                accessEnrollCourse={accessEnrollCourse}
                openSidebarToggle={openSidebarToggle}
                OpenSidebar={OpenSidebar}
                // showOtpReg={showOtpReg}
                // accessOtpReg={accessOtpReg}
                closeBar={closeBar}
                // showUserDetailReg={showUserDetailReg}
                // accessUserDetailReg={accessUserDetailReg}
            />
        </div>
    )
}

export default Home